import React, { useContext, useEffect, useRef, useState } from 'react'
import { Context } from '../context/Context';
import audio from '../audios/sample_audio_1.mp3'
import listeningMusic from '../assets/green/listening_music_white_bg.png'
import musicPlay from "../assets/green/play2.png";
import musicPause from "../assets/green/pause2.png";
import AudioComponent from '../commonComponents/AudioComponent';
import { useHistory } from 'react-router-dom';

import playVideo from '../assets/videos/play_button.png'

import './ramdan.css'
import axios from 'axios';
import { base, getHeaders } from '../Config';
import Ramadan from '../commonComponents/Ramadan';
import { SendGuiDataEvents } from '../lib/CommonScript';
// import listeningMusic from '../assets/green/listening_music_white_bg.png'
// import musicPlay from "../assets/green/play2.png";
// import musicPause from "../assets/green/pause2.png";



function Hajj() {
  const { lang, theme } = useContext(Context);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false)
  const history = useHistory();
  const [videoPlay, setVideoPlay] = useState(false)
  const videoRef = useRef(null)
  const [hajjApiData, setHajjApiData] = useState([])
  const [ramadanVid, setRamadanVid] = useState()
  // const [ramadanSpecial, setRamadanSpecial] = useState()
  // const [ramadanDua, setRamadanDua] = useState()
  // const [ramadanNasheed, setRamadanNasheed] = useState()
  // const [ramadanRelay, setRamadanRelay] = useState()
  const [hajjAudio, setHajjAudio] = useState()
  const [currentPlayedAudio, setCurrentPlayedAudio] = useState()
  const { handleShowLoader } = useContext(Context)
  const [refSave , setRefSave] = useState(null)



  // find the bug in the onClickHandler function

  const refHandler = ( ref ) => {
    setVideoPlay(false)
    if(!refSave){
      setRefSave(ref)
    }else{
      refSave.current.pause()
      setRefSave(ref)
    }

  }


  useEffect(() => {
    //send gui events
    let guiDataEvent = {};
    guiDataEvent["w_action"] = "card_click";
        guiDataEvent["name"] = "hajj";
    SendGuiDataEvents(guiDataEvent);
  }, []);


  const onClickHandler = (index, data, key , ref) => {

    console.log(index, data)
    setCurrentPlayedAudio(data)

    console.log("audioRef.current", audioRef.current)

    console.log("hajjAudio[key].data[index].name", hajjAudio[key].data[index].name)
    console.log("data.name", data.name)

    console.log("checking condition", isPlaying && data.name === hajjAudio[key].data[index].name);


    if (isPlaying && data.name === hajjAudio[key].data[index].name) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }

  };





  const hajjApi = async () => {
    handleShowLoader(true)
    const response = await axios({
      // url: base + "ramadan",
      url: base + "hajjData",
      method: 'post',
      headers: getHeaders()
    });

    handleShowLoader(false)

    setHajjApiData(response.data)
    // setRamadanVid(response.data?.hajjJson?.video[0])
    // setHajjAudio(response.data?.ramadanJson?.audio)
    setHajjAudio(response.data?.hajjData)


  }

  useEffect(() => {
    hajjApi()
  }, [])



  const onPlayFunctionVideo = (index) => {
    if(refSave){
      refSave.current.pause()
      setRefSave(null)
    }
    setVideoPlay(index)
  }



  console.log("hajj api data", hajjApiData)

  // setRamadanVid(hajjApiData?.ramadanJson?.video)
//   console.log("ramadanVid", ramadanVid)
  console.log("hajjAudio", hajjAudio)

  // setRamadanSpecial(result.data?.ramadanJson[1])
  // setRamadanDua(result.data?.ramadanJson[2])
  // setRamadanNasheed(result.data?.ramadanJson[3])
  // setRamadanRelay(result.data?.ramadanJson[4])



  return (
    <div className={`absolute pt-20 bg-green max-w-[500px] w-full min-h-screen bg-center bg-cover text-black ${theme === "red" ? "bg-red_bg_pic" : "bg-green_bg_pic"}`}>

      {hajjAudio?.map((data, key) => {
        return <div>
          <div className="bg-surah_name_board mt-4 bg-50% h-12 text-white font-bold bg-center bg-no-repeat w-full py-2">
            {/* {data?.ramadanCategory} */}
            {data?.hajjCategory}
          </div>

          <div className=''>
            <div className=' text-right cursor-pointer text-white mr-2' onClick={() => history.push(
              {
                // pathname: "/allAudios",
                state: { audioData: data }
              }
            )}></div>

            <div className='flex flex-col px-8 md:mr-10  mt-6'>

              {/* <AudioComponent /> */}
              {/* <AudioComponent /> */}

              {data?.data?.map((data, index) => {

                return   <AudioComponent name={data?.name} link={data?.link} refHandler={refHandler} parentRef={refSave}/>

              })}

            </div>
          </div>
        </div>
      })}





    </div>
  )
}

export default Hajj